module.exports = __webpack_public_path__ + "img/pic2.81cc4a0e.webp";